<template>

  <div>

    <div v-if="permissions.includes('manage_candidates')">
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To request a video questionnaire, select a job') }}
      </div>

      <div v-if="resourceAvailability.features.includes('voice_interview')">
        <div v-if="!candidate.email"
          class="alert alert-warning">
          O candidato não possui e-mail
        </div>
        <div
          v-if="selectedJob && candidate.email"
          class="card">
          <div class="card-body">
            <CandidateIntervoiceInvite />
          </div>
        </div>
      </div>
      <div v-else>
        <Unavailable
          title="Entrevistas de voz" />
      </div>
    </div>

    <CandidateIntervoiceInviteList />
    <CandidateFeed :activityType="'intervoice'" />

  </div>

</template>

<script>
import CandidateIntervoiceInvite from './CandidateIntervoiceInvite'
import CandidateIntervoiceInviteList from './CandidateIntervoiceInviteList'
import CandidateFeed from '../Feed/CandidateFeed'
import Unavailable from '../../Unavailable/Unavailable'

export default {
  name: 'CandidateIntervoice',
  components: {
    CandidateIntervoiceInvite,
    CandidateIntervoiceInviteList,
    CandidateFeed,
    Unavailable
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Intervoice/CandidateIntervoice.vue